var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "upload-status-banner",
    class: _vm.bannerClass,
    attrs: {
      "role": "status",
      "aria-live": "polite"
    }
  }, [_c('div', {
    staticClass: "upload-status-banner__main"
  }, [_c('v-icon', {
    staticClass: "upload-status-banner__icon",
    attrs: {
      "color": _vm.iconColor
    }
  }, [_vm._v(" " + _vm._s(_vm.icon) + " ")]), _c('div', {
    staticClass: "upload-status-banner__copy"
  }, [_c('div', {
    staticClass: "upload-status-banner__label"
  }, [_vm._v(_vm._s(_vm.label))]), _c('div', {
    staticClass: "upload-status-banner__value"
  }, [_vm.busy ? [_c('strong', [_vm._v(_vm._s(_vm.uploaded))]), _vm._v(" of "), _c('strong', [_vm._v(_vm._s(_vm.expectedCount))]), _vm._v(" videos uploaded ")] : [_vm._v(" " + _vm._s(_vm.idleValue) + " ")]], 2), _vm.hint ? _c('div', {
    staticClass: "upload-status-banner__hint"
  }, [_vm._v(" " + _vm._s(_vm.hint) + " ")]) : _vm._e()]), _vm.busy ? _c('div', {
    staticClass: "upload-status-banner__count",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v(" " + _vm._s(_vm.uploaded) + "/" + _vm._s(_vm.expectedCount) + " ")]) : _vm._e()], 1), _vm.busy ? _c('v-progress-linear', {
    staticClass: "upload-status-banner__progress",
    attrs: {
      "value": _vm.progressPercent,
      "indeterminate": _vm.expectedCount === 0,
      "height": "8",
      "rounded": "",
      "color": _vm.iconColor,
      "background-color": "rgba(0, 0, 0, 0.08)"
    }
  }) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }